export const MULTIPLE_MEDIA_LIMIT = 10;
export const VISIBLE_MULTIPLE_MEDIA_LIMIT = 4;
export const MAX_CAPTION_LENGTH = 250;
